var map = {
	"./": 8063,
	"./0001.jpg": 3297,
	"./001.jpg": 5899,
	"./002.jpg": 9452,
	"./003.jpg": 7241,
	"./004.jpg": 1402,
	"./006.jpg": 1016,
	"./App": 4111,
	"./App.css": 4050,
	"./App.js": 4111,
	"./Bstructuring1.jpg": 5311,
	"./Business1.jpg": 7269,
	"./Case1.jpg": 4623,
	"./Clinic1.jpg": 8147,
	"./Contact1.jpg": 3485,
	"./Corporate1.jpg": 7686,
	"./Corporatelaw1.jpg": 2006,
	"./Criminal1.jpg": 1338,
	"./Document1.jpg": 1590,
	"./Employment1.jpg": 9677,
	"./Family1.jpg": 8263,
	"./Gorvenance1.jpg": 1965,
	"./Hero.png": 3828,
	"./Hero1.png": 2711,
	"./Intellectaul1.jpg": 4833,
	"./International1.jpg": 4509,
	"./Lawyer1.png": 6143,
	"./Lawyer2png.jpg": 6039,
	"./Lawyer3png.jpg": 4128,
	"./Lawyer4png.jpg": 2425,
	"./Lawyer5png.jpg": 1674,
	"./Legalnews1.jpg": 2531,
	"./Litigation1.jpg": 1785,
	"./Mergers1.jpg": 5126,
	"./Realestate1.jpg": 3675,
	"./School1.jpg": 2887,
	"./Success1.jpg": 8690,
	"./Tax1.jpg": 6360,
	"./about.jpg": 7189,
	"./atlantalife.png": 8117,
	"./community.jpg": 4165,
	"./community1.jpg": 8588,
	"./components/Edwardslawfirm": 6677,
	"./components/Edwardslawfirm.js": 6677,
	"./components/Footer": 834,
	"./components/Footer.js": 834,
	"./components/GlobeSection": 8966,
	"./components/GlobeSection.js": 8966,
	"./components/Navbar": 2999,
	"./components/Navbar.js": 2999,
	"./corporate.jpg": 4331,
	"./criminal.jpg": 5975,
	"./employment.jpg": 2914,
	"./familylaw.jpg": 2830,
	"./fifth.jpg": 9189,
	"./first.jpg": 6216,
	"./fourth.jpg": 5608,
	"./index": 8063,
	"./index.css": 9555,
	"./index.js": 8063,
	"./intellectual.jpg": 5134,
	"./international.jpg": 8786,
	"./lawyer1.jpg": 2319,
	"./lawyer2.jpg": 5680,
	"./lawyer3.jpg": 1245,
	"./lawyer4.jpg": 4374,
	"./lawyer5.jpg": 5987,
	"./lawyers.jpg": 3869,
	"./logo.svg": 9445,
	"./pages/BusinessPage": 7382,
	"./pages/BusinessPage.js": 7382,
	"./pages/CasePage": 7472,
	"./pages/CasePage.js": 7472,
	"./pages/CommunityPage": 6781,
	"./pages/CommunityPage.js": 6781,
	"./pages/Contactpage": 7104,
	"./pages/Contactpage.js": 7104,
	"./pages/CorporatePage": 7031,
	"./pages/CorporatePage.js": 7031,
	"./pages/Corporatelaw": 9658,
	"./pages/Corporatelaw.js": 9658,
	"./pages/Criminaldefense": 7864,
	"./pages/Criminaldefense.js": 7864,
	"./pages/DocumentPage": 2841,
	"./pages/DocumentPage.js": 2841,
	"./pages/Employmentlaw": 9331,
	"./pages/Employmentlaw.js": 9331,
	"./pages/Familylaw": 9907,
	"./pages/Familylaw.js": 9907,
	"./pages/IntellectualProperty.css": 3545,
	"./pages/Internationaltrade": 1321,
	"./pages/Internationaltrade.js": 1321,
	"./pages/LegalnewsPage": 7974,
	"./pages/LegalnewsPage.js": 7974,
	"./pages/LitigationPage": 3874,
	"./pages/LitigationPage.js": 3874,
	"./pages/RealEstateLaw.css": 7986,
	"./pages/Realestatelaw": 2223,
	"./pages/Realestatelaw.js": 2223,
	"./pages/SuccesPage": 7358,
	"./pages/SuccesPage.js": 7358,
	"./pages/Taxadvisory": 6349,
	"./pages/Taxadvisory.js": 6349,
	"./pages/ThankYouPage": 1566,
	"./pages/ThankYouPage.js": 1566,
	"./pages/Tuallaw": 8693,
	"./pages/Tuallaw.js": 8693,
	"./realestate.jpg": 1372,
	"./reportWebVitals": 9031,
	"./reportWebVitals.js": 9031,
	"./second.jpg": 1436,
	"./seventh.jpg": 721,
	"./sixth.jpg": 5382,
	"./tax.jpg": 6665,
	"./third.jpg": 341,
	"./welcome.jpg": 2754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5538;